"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props) {
  var active = props.active,
      passed = props.passed,
      vertical = props.vertical,
      palette = theme.palette,
      number = _objectSpread({}, theme.number),
      content = _objectSpread({}, theme),
      hint = _objectSpread({}, theme.hint);

  if (active) {
    number.background = number.activeBackground;
    number.color = number.activeColor;
    number.icon = number.activeIcon;
    content.color = content.activeColor;
  } else if (passed) {
    number.background = number.passedBackground;
    number.color = number.passedColor;
    number.icon = number.passedIcon;
    content.color = content.passedColor;
  }

  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start'
    },
    number: {
      width: number.width,
      height: number.height,
      borderRadius: number.borderRadius,
      color: number.color,
      background: number.background,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      icon: number.icon,
      marginRight: number.marginRight,
      transitionProperty: 'background, color',
      transitionTimingFunction: palette.transitionFunction,
      transitionDuration: palette.transitionDuration
    },
    labelWrapper: {
      position: 'relative'
    },
    name: {
      fontSize: content.fontSize,
      lineHeight: number.height,
      color: content.color,
      fontWeight: content.fontWeight,
      whiteSpace: content.whiteSpace,
      transitionProperty: 'color',
      transitionTimingFunction: palette.transitionFunction,
      transitionDuration: palette.transitionDuration
    },
    hint: {
      position: vertical ? 'absolute' : 'relative',
      left: 0,
      top: '100%',
      fontSize: hint.fontSize,
      lineHeight: hint.lineHeight,
      color: hint.color,
      fontWeight: hint.fontWeight
    }
  };
}